import { useEffect } from 'react';

import { loadScript, loadStylesheet } from '@vk-hr-tek/core/external-resource';

import {
  PORTAL_HEADER_DATA_URL,
  PORTAL_HEADER_SCRIPT_URL,
  PORTAL_HEADER_STYLES_URL,
  PORTAL_MENU_DATA_ID,
} from '../../../constants';

/**
 * Подключает ресурсы портального меню (data-link, css и js) и удаляет их при размонтировании.
 */
export const usePortalResources = () => {
  useEffect(() => {
    const dataLink = document.createElement('link');

    dataLink.id = PORTAL_MENU_DATA_ID;
    dataLink.rel = 'preload';
    dataLink.setAttribute('as', 'fetch');
    dataLink.type = 'application/json';
    dataLink.href = PORTAL_HEADER_DATA_URL;

    document.head.appendChild(dataLink);

    const removeStylesheet = loadStylesheet(PORTAL_HEADER_STYLES_URL);
    const removeScript = loadScript(PORTAL_HEADER_SCRIPT_URL);

    return () => {
      dataLink.remove();
      removeStylesheet();
      removeScript();
    };
  }, []);
};
